import { DataTableVariant } from './DataTable.types'

export const DATA_TABLE_INDEX_COLUMN_WIDTH = 40

export type DataTableTypographyVariant = '18x600' | '16x600' | '18x400' | '16x400'

export type DataTableVariantConfig = {
    actionsColumnWidth: number
    hasStripedRows: boolean
    hasRoundedCorners: boolean
    headerTypographyVariant: DataTableTypographyVariant
    bodyTypographyVariant: DataTableTypographyVariant
    cellPaddingX: number
    cellPaddingY: number
    minTableWidth: number
}

export const DATA_TABLE_VARIANTS: Record<DataTableVariant, DataTableVariantConfig> = {
    primary: {
        actionsColumnWidth: 52,
        hasStripedRows: true,
        hasRoundedCorners: true,
        headerTypographyVariant: '18x600',
        bodyTypographyVariant: '18x400',
        cellPaddingX: 2,
        cellPaddingY: 2,
        minTableWidth: 720,
    },
    nested: {
        actionsColumnWidth: 32,
        hasStripedRows: false,
        hasRoundedCorners: false,
        headerTypographyVariant: '16x600',
        bodyTypographyVariant: '16x400',
        cellPaddingX: 1,
        cellPaddingY: 0.5,
        minTableWidth: 640,
    },
}
